import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import styles from "./PageHeader.module.scss";
import Breadcrumbs from "components/Breadcrumbs/Breadcrumbs";
import Stat from "./components/Stat/Stat";
import { loadStatsAction } from "store/actions/Actions";


/**
 *
 * @param {*} [children] - children to render
 * @param {String} [className] - additional className to add
 * @param {String} [heading] - heading to show instead of children (heading will override children)
 * @param {Boolean} [showStats] - whether to show stats button
 * @param {Boolean} [showHints] - whether to show hints button
 * @param {Function} [disableHints] - onClick event handler to disable hints (should be a setState prop, where the state is in the parent)
 */
const PageHeader = props => {
    const [showStats, setShowStats] = useState(true)
    const { StatsReducer, loadStatsAction, loadStats = true, title } = props;

    const toggleStats = e => {
        setShowStats(!showStats)
    }

    useEffect(() => {
        if (!StatsReducer.stats && loadStats) {
            loadStatsAction();
        }
    }, [StatsReducer.stats, loadStatsAction, loadStats]);

    let hints = ""
    if (props.hints) {
        hints = (
            <div className={styles["hints"]}>
                <i className="far fa-question-circle" />
                <span onClick={props.disableHints}>Hide Helpful Hints</span>
            </div>
        )
    }

    return (
        <div className={`${styles["page-header"]} ${props.className || ""}`}>
            <div className={styles["page-header-container"]}>
                {!title ? <Breadcrumbs className={styles.breadcrumbs} breadcrumbs={props.breadcrumbs}/> : <h1>{title}</h1>}

                {props.showStats &&
                    <div className={styles["show-stats"]} onClick={toggleStats}>
                        <i className={`fas fa-sort-down ${styles["show-stats-icon"]} ${showStats ? styles["active"] : ""}`} />
                        <i className={`fad fa-chart-bar ${styles["chart-icon"]} ${showStats ? styles["active"] : ""}`} />
                    </div>
                }
            </div>

            {props.showStats &&
                <div className={`${styles.stats} ${showStats ? "" : styles["hide-stats"]}`}>
                    <Stat key="stats-key-1" statData={StatsReducer.stats && StatsReducer.stats.audits && StatsReducer.stats.audits.total} statName="Audits" link="/achieve/audits" iconClass="fad fa-cabinet-filing" />
                    <Stat key="stats-key-2" statData={StatsReducer.stats && StatsReducer.stats.remediation && StatsReducer.stats.remediation.total} statName="Remediation" link="/achieve/remediation" iconClass="fad fa-file-search" />
                    <Stat key="stats-key-3" statData={StatsReducer.stats && StatsReducer.stats.tasks && StatsReducer.stats.tasks.total} statName="Organization Tasks" link="/achieve/tasks?filter=all" iconClass="fad fa-tasks" />
                    <Stat key="stats-key-4" statData={StatsReducer.stats && StatsReducer.stats.attestation && StatsReducer.stats.attestation.total} statName="Attestation" link="/achieve/tasks?filter=attestation" iconClass="fad fa-users-class" />
                    <Stat key="stats-key-5" statData={StatsReducer.stats && StatsReducer.stats.incidents && StatsReducer.stats.incidents.total} statName="Incidents" link="/maintain/incidents" iconClass="fad fa-exclamation-triangle" />
                </div>
            }
    
            {(props.children || props.heading) &&
            <div className={styles["page-header-children"]}>
                {props.heading ? (
                    <span className={styles.heading}>
                        {props.heading}
                        {hints}
                    </span>
                ) : (
                    props.children || ""
                )}
            </div>
            }
        </div>
    );
};

const mapStateToProps = (state) => ({
    StatsReducer: state.StatsReducer,
});

const mapDispatchToProps = {
    loadStatsAction,
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(PageHeader)
);
